import Inspiration from '../models/Inspiration'
import { createResourceModule } from '../utils/store'

export default createResourceModule('inspirations', Inspiration)
